"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import type { JobadComponentProps } from "~/types/job";
export default function ApplicationGuideEonUk(_props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p>To help you feel confident at every stage, we've provided more detail about our application process and shared My Skill Guide - our framework that brings our purpose, strategy and attitude to life. You'll also find practical tips to help you submit a strong application.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div>{t0}<p className="mt-4"><CustomLink blank={true} className="font-medium text-primary underline" href="https://www.eon-uk-careers.com/en/job-search/application-process.html">Find out more.</CustomLink></p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="w-full px-6 py-10 text-lg md:px-10 md:py-20 print:hidden" id="applicationGuide"><div className="mx-auto grid max-w-screen-xl items-center gap-10 lg:grid-cols-2">{t1}<div className="flex justify-center"><CustomImage alt="Application guide" className="object-cover" height={400} src="images/jobad/uk/EON_YoungTalents25_38306.webp" width={500} /></div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}